import { RequestItem } from '@/components/cards/request-data/request-item'
import { useWorkloadSummary } from '@/hooks/domain/review/use-workload-summary'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'
import { formatWorkloadHours } from '@/utils/format-workload-hours'

interface CoursesEquivalencesWorkloadFooterProps {
  formMethods?: StudentRequestedCoursesFormMethods
  curriculumCourses?: DesiredEducationCourse[]
}

function formatPercentage(percentage: number | null) {
  return percentage === null ? '--' : `${percentage}%`
}

export const CoursesEquivalencesWorkloadFooter = ({
  formMethods,
  curriculumCourses
}: CoursesEquivalencesWorkloadFooterProps) => {
  const { grantedWorkload, totalWorkload, percentage } = useWorkloadSummary(
    formMethods,
    curriculumCourses
  )

  return (
    <div className="flex justify-between gap-4 border-t border-ring/50 px-6 py-3">
      <RequestItem
        label="Aproveitamento Atual do Currículo"
        value={formatPercentage(percentage)}
      />
      <p className="text-foreground/50">
        Carga horária aproveitada: {formatWorkloadHours(grantedWorkload)} de{' '}
        {formatWorkloadHours(totalWorkload)} do currículo desejado
      </p>
    </div>
  )
}
